import React, { useMemo, useState, useEffect, useReducer } from "react";
import { Edit } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import api from "../../../../_core/api";
import * as S from "../styles";
import { Button, Table, Modal } from "../../../../_core/_components";
import { handleErrors, success } from "../../../../_core/services/toast";
import { FullScreenLoading } from "../../../../_core/_components/fullscreen-loading";
import { INITIAL_STATE, reducer } from "./reducer";
import ModalContent from "./modal-content";

export const TipoDivida: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tipoDividaList, setTipoDividaList] = useState<any[]>([]);
  const [form, dispatch] = useReducer(reducer, undefined);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.post(`/api/cartas/tipodivida/buscar`, {
        nomeDivida: "",
        codigoContrato: "",
        tipoDocumentos: "",
        tipoMovimentos: "",
      });
      setTipoDividaList(data.content);
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const onClickSave = async () => {
    try {
      setIsLoading(true);
      await api.post(`/api/cartas/tipodivida/salvar`, form);
      dispatch({ type: "UNSET_TIPO_DIVIDA" });
      const { data } = await api.post(`/api/cartas/tipodivida/buscar`, {
        nomeDivida: "",
        codigoContrato: "",
        tipoDocumentos: "",
        tipoMovimentos: "",
      });
      setTipoDividaList(data.content);
      success("Tipo dívida salvo com sucesso.");
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  };

  const data = useMemo(() => {
    return tipoDividaList.map((e) => ({
      ...e,
      editar: (
        <IconButton
          onClick={() =>
            dispatch({
              type: "SET_TIPO_DIVIDA",
              payload: {
                ...e,
              },
            })
          }
        >
          <Edit />
        </IconButton>
      ),
    }));
  }, [tipoDividaList]);

  return (
    <>
      {form && (
        <Modal
          title="Adicionar / Alterar Tipo Dívida"
          onClose={() => dispatch({ type: "UNSET_TIPO_DIVIDA" })}
          content={<ModalContent form={form} dispatch={dispatch} />}
          actionItems={[<Button onClick={onClickSave} text="Salvar" />]}
        />
      )}
      <FullScreenLoading isEnabled={isLoading} />
      <S.DataContainer>
        <S.TopBar>
          <S.SearchBar></S.SearchBar>
          <Button
            text="Novo"
            onClick={() =>
              dispatch({ type: "SET_TIPO_DIVIDA", payload: INITIAL_STATE })
            }
            styles={{ width: 100 }}
          />
        </S.TopBar>
        {tipoDividaList.length > 0 && (
          <Table
            columns={[
              { label: "Nome", key: "nomeDivida" },
              { label: "Codigo contrato", key: "codigoContrato" },
              { label: "Tipo documento", key: "tipoDocumentos" },
              { label: "Tipo movimento", key: "tipoMovimentos" },
              { label: "Editar", key: "editar" },
            ]}
            data={data}
          />
        )}
      </S.DataContainer>
    </>
  );
};
